import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminTickets from './AdminTickets';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const COUNTRIES = [
    { id: 1, name: 'Mexico' }, { id: 2, name: 'United States' }, { id: 3, name: 'Aruba' },
    { id: 4, name: 'Afghanistan' }, { id: 5, name: 'Angola' }, { id: 6, name: 'Anguilla' },
    { id: 7, name: 'Åland Islands' }, { id: 8, name: 'Albania' }, { id: 9, name: 'Andorra' },
    { id: 10, name: 'Netherlands Antilles' }, { id: 11, name: 'United Arab Emirates' },
    { id: 12, name: 'Argentina' }, { id: 13, name: 'Armenia' }, { id: 14, name: 'American Samoa' },
    { id: 15, name: 'Antarctica' }, { id: 16, name: 'French Southern Territories' },
    { id: 17, name: 'Antigua and Barbuda' }, { id: 18, name: 'Australia' }, { id: 19, name: 'Austria' },
    { id: 20, name: 'Azerbaijan' }, { id: 21, name: 'Burundi' }, { id: 22, name: 'Belgium' },
    { id: 23, name: 'Benin' }, { id: 24, name: 'Burkina Faso' }, { id: 25, name: 'Bangladesh' },
    { id: 26, name: 'Bulgaria' }, { id: 27, name: 'Bahrain' }, { id: 28, name: 'Bahamas' },
    { id: 29, name: 'Bosnia and Herzegovina' }, { id: 30, name: 'Saint Barthélemy' },
    { id: 31, name: 'Belarus' }, { id: 32, name: 'Belize' }, { id: 33, name: 'Bermuda' },
    { id: 34, name: 'Bolivia, Plurinational State of' }, { id: 35, name: 'Brazil' },
    { id: 36, name: 'Barbados' }, { id: 37, name: 'Brunei Darussalam' }, { id: 38, name: 'Bhutan' },
    { id: 39, name: 'Bouvet Island' }, { id: 40, name: 'Botswana' },
    { id: 41, name: 'Central African Republic' }, { id: 42, name: 'Canada' },
    { id: 43, name: 'Cocos (Keeling) Islands' }, { id: 44, name: 'Switzerland' },
    { id: 45, name: 'Chile' }, { id: 46, name: 'China' }, { id: 47, name: 'Cote dIvoire' },
    { id: 48, name: 'Cameroon' }, { id: 49, name: 'Congo, Democratic Republic' },
    { id: 50, name: 'Congo' }, { id: 51, name: 'Cook Islands' }, { id: 52, name: 'Colombia' },
    { id: 53, name: 'Comoros' }, { id: 54, name: 'Cape Verde' }, { id: 55, name: 'Costa Rica' },
    { id: 56, name: 'Cuba' }, { id: 57, name: 'Christmas Island' }, { id: 58, name: 'Cayman Islands' },
    { id: 59, name: 'Cyprus' }, { id: 60, name: 'Czech Republic' }, { id: 61, name: 'Germany' },
    { id: 62, name: 'Djibouti' }, { id: 63, name: 'Dominica' }, { id: 64, name: 'Denmark' },
    { id: 65, name: 'Dominican Republic' }, { id: 66, name: 'Algeria' }, { id: 67, name: 'Ecuador' },
    { id: 68, name: 'Egypt' }, { id: 69, name: 'Eritrea' }, { id: 70, name: 'Western Sahara' },
    { id: 71, name: 'Spain' }, { id: 72, name: 'Estonia' }, { id: 73, name: 'Ethiopia' },
    { id: 74, name: 'Finland' }, { id: 75, name: 'Fiji' }, { id: 76, name: 'Falkland Islands (Malvinas)' },
    { id: 77, name: 'France' }, { id: 78, name: 'Faroe Islands' },
    { id: 79, name: 'Micronesia, Federated States of' }, { id: 80, name: 'Gabon' },
    { id: 81, name: 'United Kingdom' }, { id: 82, name: 'Georgia' }, { id: 83, name: 'Guernsey' },
    { id: 84, name: 'Ghana' }, { id: 85, name: 'Gibraltar' }, { id: 86, name: 'Guinea' },
    { id: 87, name: 'Guadeloupe' }, { id: 88, name: 'Gambia' }, { id: 89, name: 'Guinea-Bissau' },
    { id: 90, name: 'Equatorial Guinea' }, { id: 91, name: 'Greece' }, { id: 92, name: 'Grenada' },
    { id: 93, name: 'Greenland' }, { id: 94, name: 'Guatemala' }, { id: 95, name: 'French Guiana' },
    { id: 96, name: 'Guam' }, { id: 97, name: 'Guyana' }, { id: 98, name: 'Hong Kong' },
    { id: 99, name: 'Heard Island and McDonald Islands' }, { id: 100, name: 'Honduras' },
    { id: 101, name: 'Croatia' }, { id: 102, name: 'Haiti' }, { id: 103, name: 'Hungary' },
    { id: 104, name: 'Indonesia' }, { id: 105, name: 'Isle of Man' }, { id: 106, name: 'India' },
    { id: 107, name: 'British Indian Ocean Territory' }, { id: 108, name: 'Ireland' },
    { id: 109, name: 'Iran, Islamic Republic of' }, { id: 110, name: 'Iraq' },
    { id: 111, name: 'Iceland' }, { id: 112, name: 'Israel' }, { id: 113, name: 'Italy' },
    { id: 114, name: 'Jamaica' }, { id: 115, name: 'Jersey' }, { id: 116, name: 'Jordan' },
    { id: 117, name: 'Japan' }, { id: 118, name: 'Kazakhstan' }, { id: 119, name: 'Kenya' },
    { id: 120, name: 'Kyrgyzstan' }, { id: 121, name: 'Cambodia' }, { id: 122, name: 'Kiribati' },
    { id: 123, name: 'Saint Kitts and Nevis' }, { id: 124, name: 'Korea, Republic of' },
    { id: 125, name: 'Kuwait' }, { id: 126, name: 'Lao People Democratic Republic' },
    { id: 127, name: 'Lebanon' }, { id: 128, name: 'Liberia' }, { id: 129, name: 'Libyan Arab Jamahiriya' },
    { id: 130, name: 'Saint Lucia' }, { id: 131, name: 'Liechtenstein' }, { id: 132, name: 'Sri Lanka' },
    { id: 133, name: 'Lesotho' }, { id: 134, name: 'Lithuania' }, { id: 135, name: 'Luxembourg' },
    { id: 136, name: 'Latvia' }, { id: 137, name: 'Macao' }, { id: 138, name: 'Saint Martin (French part)' },
    { id: 139, name: 'Morocco' }, { id: 140, name: 'Monaco' }, { id: 141, name: 'Moldova, Republic of' },
    { id: 142, name: 'Madagascar' }, { id: 143, name: 'Maldives' }, { id: 144, name: 'Marshall Islands' },
    { id: 145, name: 'Macedonia' }, { id: 146, name: 'Mali' }, { id: 147, name: 'Malta' },
    { id: 148, name: 'Myanmar' }, { id: 149, name: 'Montenegro' }, { id: 150, name: 'Mongolia' },
    { id: 151, name: 'Northern Mariana Islands' }, { id: 152, name: 'Mozambique' },
    { id: 153, name: 'Mauritania' }, { id: 154, name: 'Montserrat' }, { id: 155, name: 'Martinique' },
    { id: 156, name: 'Mauritius' }, { id: 157, name: 'Malawi' }, { id: 158, name: 'Malaysia' },
    { id: 159, name: 'Mayotte' }, { id: 160, name: 'Namibia' }, { id: 161, name: 'New Caledonia' },
    { id: 162, name: 'Niger' }, { id: 163, name: 'Norfolk Island' }, { id: 164, name: 'Nigeria' },
    { id: 165, name: 'Nicaragua' }, { id: 166, name: 'Niue' }, { id: 167, name: 'Netherlands' },
    { id: 168, name: 'Norway' }, { id: 169, name: 'Nepal' }, { id: 170, name: 'Nauru' },
    { id: 171, name: 'New Zealand' }, { id: 172, name: 'Oman' }, { id: 173, name: 'Pakistan' },
    { id: 174, name: 'Panama' }, { id: 175, name: 'Pitcairn' }, { id: 176, name: 'Peru' },
    { id: 177, name: 'Philippines' }, { id: 178, name: 'Palau' }, { id: 179, name: 'Papua New Guinea' },
    { id: 180, name: 'Poland' }, { id: 181, name: 'Puerto Rico' },
    { id: 182, name: 'Korea, Democratic Republic' }, { id: 183, name: 'Portugal' },
    { id: 184, name: 'Paraguay' }, { id: 185, name: 'Palestinian Territory, Occupied' },
    { id: 186, name: 'French Polynesia' }, { id: 187, name: 'Qatar' }, { id: 188, name: 'Réunion' },
    { id: 189, name: 'Romania' }, { id: 190, name: 'Russian Federation' }, { id: 191, name: 'Rwanda' },
    { id: 192, name: 'Saudi Arabia' }, { id: 193, name: 'Sudan' }, { id: 194, name: 'Senegal' },
    { id: 195, name: 'Singapore' }, { id: 196, name: 'South Georgia and Sandwich Isl' },
    { id: 197, name: 'Saint Helena, Ascension and Tristan' }, { id: 198, name: 'Svalbard and Jan Mayen' },
    { id: 199, name: 'Solomon Islands' }, { id: 200, name: 'Sierra Leone' },
    { id: 201, name: 'El Salvador' }, { id: 202, name: 'San Marino' }, { id: 203, name: 'Somalia' },
    { id: 204, name: 'Saint Pierre and Miquelon' }, { id: 205, name: 'Serbia' },
    { id: 206, name: 'Sao Tome and Principe' }, { id: 207, name: 'Suriname' },
    { id: 208, name: 'Slovakia' }, { id: 209, name: 'Slovenia' }, { id: 210, name: 'Sweden' },
    { id: 211, name: 'Swaziland' }, { id: 212, name: 'Seychelles' },
    { id: 213, name: 'Syrian Arab Republic' }, { id: 214, name: 'Turks and Caicos Islands' },
    { id: 215, name: 'Chad' }, { id: 216, name: 'Togo' }, { id: 217, name: 'Thailand' },
    { id: 218, name: 'Tajikistan' }, { id: 219, name: 'Tokelau' }, { id: 220, name: 'Turkmenistan' },
    { id: 221, name: 'Timor-Leste' }, { id: 222, name: 'Tonga' },
    { id: 223, name: 'Trinidad and Tobago' }, { id: 224, name: 'Tunisia' }, { id: 225, name: 'Turkey' },
    { id: 226, name: 'Tuvalu' }, { id: 227, name: 'Taiwan, Province of China' },
    { id: 228, name: 'Tanzania, United Republic of' }, { id: 229, name: 'Uganda' },
    { id: 230, name: 'Ukraine' }, { id: 231, name: 'United States Minor Outlying Isl' },
    { id: 232, name: 'Uruguay' }, { id: 233, name: 'Uzbekistan' },
    { id: 234, name: 'Holy See (Vatican City State)' },
    { id: 235, name: 'Saint Vincent and the Grenadines' },
    { id: 236, name: 'Venezuela, Bolivarian Republic of' }, { id: 237, name: 'Virgin Islands, British' },
    { id: 238, name: 'Virgin Islands, U.S.' }, { id: 239, name: 'Viet Nam' },
    { id: 240, name: 'Vanuatu' }, { id: 241, name: 'Wallis and Futuna' }, { id: 242, name: 'Samoa' },
    { id: 243, name: 'Yemen' }, { id: 244, name: 'South Africa' }, { id: 245, name: 'Zambia' },
    { id: 246, name: 'Zimbabwe' },
];
const MEXICAN_STATES = [
    { id: 1, name: 'Aguascalientes' }, { id: 2, name: 'Baja California' },
    { id: 3, name: 'Baja California Sur' }, { id: 4, name: 'Campeche' }, { id: 5, name: 'Chiapas' },
    { id: 6, name: 'Chihuahua' }, { id: 7, name: 'Coahuila' }, { id: 8, name: 'Colima' },
    { id: 9, name: 'Ciudad de México' }, { id: 10, name: 'Durango' }, { id: 11, name: 'Guanajuato' },
    { id: 12, name: 'Guerrero' }, { id: 13, name: 'Hidalgo' }, { id: 14, name: 'Jalisco' },
    { id: 15, name: 'Estado de México' }, { id: 16, name: 'Michoacán' }, { id: 17, name: 'Morelos' },
    { id: 18, name: 'Nayarit' }, { id: 19, name: 'Nuevo León' }, { id: 20, name: 'Oaxaca' },
    { id: 21, name: 'Puebla' }, { id: 22, name: 'Querétaro' }, { id: 23, name: 'Quintana Roo' },
    { id: 24, name: 'San Luis Potosí' }, { id: 25, name: 'Sinaloa' }, { id: 26, name: 'Sonora' },
    { id: 27, name: 'Tabasco' }, { id: 28, name: 'Tamaulipas' }, { id: 29, name: 'Tlaxcala' },
    { id: 30, name: 'Veracruz' }, { id: 31, name: 'Yucatán' }, { id: 32, name: 'Zacatecas' },
];
const US_STATES = [
    { id: 33, name: 'Alaska', code: 'AK' }, { id: 34, name: 'Alabama', code: 'AL' },
    { id: 35, name: 'Arkansas', code: 'AR' }, { id: 36, name: 'Arizona', code: 'AZ' },
    { id: 37, name: 'California', code: 'CA' }, { id: 38, name: 'Colorado', code: 'CO' },
    { id: 39, name: 'Connecticut', code: 'CT' }, { id: 40, name: 'Delaware', code: 'DE' },
    { id: 41, name: 'Florida', code: 'FL' }, { id: 42, name: 'Georgia', code: 'GA' },
    { id: 43, name: 'Hawaii', code: 'HI' }, { id: 44, name: 'Iowa', code: 'IA' },
    { id: 45, name: 'Idaho', code: 'ID' }, { id: 46, name: 'Illinois', code: 'IL' },
    { id: 47, name: 'Indiana', code: 'IN' }, { id: 48, name: 'Kansas', code: 'KS' },
    { id: 49, name: 'Kentucky', code: 'KY' }, { id: 50, name: 'Louisiana', code: 'LA' },
    { id: 51, name: 'Massachusetts', code: 'MA' }, { id: 52, name: 'Maryland', code: 'MD' },
    { id: 53, name: 'Maine', code: 'ME' }, { id: 54, name: 'Michigan', code: 'MI' },
    { id: 55, name: 'Minnesota', code: 'MN' }, { id: 56, name: 'Missouri', code: 'MO' },
    { id: 57, name: 'Mississippi', code: 'MS' }, { id: 58, name: 'Montana', code: 'MT' },
    { id: 59, name: 'North Carolina', code: 'NC' }, { id: 60, name: 'North Dakota', code: 'ND' },
    { id: 61, name: 'Nebraska', code: 'NE' }, { id: 62, name: 'New Hampshire', code: 'NH' },
    { id: 63, name: 'New Jersey', code: 'NJ' }, { id: 64, name: 'New Mexico', code: 'NM' },
    { id: 65, name: 'Nevada', code: 'NV' }, { id: 66, name: 'New York', code: 'NY' },
    { id: 67, name: 'Ohio', code: 'OH' }, { id: 68, name: 'Oklahoma', code: 'OK' },
    { id: 69, name: 'Oregon', code: 'OR' }, { id: 70, name: 'Pennsylvania', code: 'PA' },
    { id: 71, name: 'Rhode Island', code: 'RI' }, { id: 72, name: 'South Carolina', code: 'SC' },
    { id: 73, name: 'South Dakota', code: 'SD' }, { id: 74, name: 'Tennessee', code: 'TN' },
    { id: 75, name: 'Texas', code: 'TX' }, { id: 76, name: 'Utah', code: 'UT' },
    { id: 77, name: 'Virginia', code: 'VA' }, { id: 78, name: 'Vermont', code: 'VT' },
    { id: 79, name: 'Washington', code: 'WA' }, { id: 80, name: 'Wisconsin', code: 'WI' },
    { id: 81, name: 'West Virginia', code: 'WV' }, { id: 82, name: 'Wyoming', code: 'WY' },
];
const getNAStateId = (countryId: number) => {
    if (countryId <= 2) return null;
    return 83 + (countryId - 3);
};

const isFeeApplicable = (fechaInicio: string | null | undefined) => {
    if (!fechaInicio) return false;
    try {
        const d = new Date(fechaInicio);
        return d.getFullYear() > 2026 || (d.getFullYear() === 2026 && d.getMonth() >= 5);
    } catch { return false; }
};

interface Bowler {
    CLAVE: number;
    FICHANAL: number;
    NOMBRECOMPLETO: string;
    EMAIL: string;
    CONTRASENA: string;
    NOMBRE: string;
    APELLIDOP: string;
    CITY: string;
}

const AdminDashboard = () => {
    const navigate = useNavigate();
    const [admin, setAdmin] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    // Reset Password Modal State
    const [showResetModal, setShowResetModal] = useState(false);
    const [bowlers, setBowlers] = useState<Bowler[]>([]);
    const [filteredBowlers, setFilteredBowlers] = useState<Bowler[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showOnlyNoEmail, setShowOnlyNoEmail] = useState(false);
    const [selectedBowlers, setSelectedBowlers] = useState<Set<string>>(new Set());
    const [resetLoading, setResetLoading] = useState(false);
    const [resetProgress, setResetProgress] = useState({ current: 0, total: 0 });
    const [resetSuccess, setResetSuccess] = useState(false);
    const [resetError, setResetError] = useState('');
    const cancelRequested = useRef(false);

    // Set Password Modal State
    const [showSetPasswordModal, setShowSetPasswordModal] = useState(false);
    const [setPasswordBowlers, setSetPasswordBowlers] = useState<Bowler[]>([]);
    const [filteredPasswordBowlers, setFilteredPasswordBowlers] = useState<Bowler[]>([]);
    const [passwordSearchTerm, setPasswordSearchTerm] = useState('');
    const [selectedBowlerEmail, setSelectedBowlerEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [setPasswordLoading, setSetPasswordLoading] = useState(false);
    const [setPasswordSuccess, setSetPasswordSuccess] = useState(false);
    const [setPasswordError, setSetPasswordError] = useState('');

    // Recruiter Balances Modal State
    const [showRecruiterBalancesModal, setShowRecruiterBalancesModal] = useState(false);
    const [recruiterBalances, setRecruiterBalances] = useState<any[]>([]);
    const [recruiterBalancesLoading, setRecruiterBalancesLoading] = useState(false);
    const [recruiterBalancesError, setRecruiterBalancesError] = useState('');

    // Recruiter Rosters modal
    const [showRecruiterRostersModal, setShowRecruiterRostersModal] = useState(false);
    const [allRecruiters, setAllRecruiters] = useState<any[]>([]);
    const [allRecruitersLoading, setAllRecruitersLoading] = useState(false);
    const [selectedRosterRecruiter, setSelectedRosterRecruiter] = useState<any | null>(null);
    const [rosterTournaments, setRosterTournaments] = useState<any[]>([]);
    const [rosterTournamentsLoading, setRosterTournamentsLoading] = useState(false);
    const [selectedRosterTournament, setSelectedRosterTournament] = useState<any | null>(null);
    const [rosterBowlers, setRosterBowlers] = useState<any[]>([]);
    const [rosterBowlersLoading, setRosterBowlersLoading] = useState(false);
    const [rosterSearch, setRosterSearch] = useState('');
    const [expandedRecruiter, setExpandedRecruiter] = useState<number | null>(null);

    // Bowlers with password counter (header)
    const [withPasswordCount, setWithPasswordCount] = useState<number | null>(null);

    // Edit Bowler Info Modal State
    const [showEditBowlerModal, setShowEditBowlerModal] = useState(false);
    const [editBowlerList, setEditBowlerList] = useState<Bowler[]>([]);
    const [filteredEditBowlers, setFilteredEditBowlers] = useState<Bowler[]>([]);
    const [editBowlerSearch, setEditBowlerSearch] = useState('');
    const [editBowlerData, setEditBowlerData] = useState<any>(null);
    const [editForm, setEditForm] = useState<any>({});
    const [editFetchLoading, setEditFetchLoading] = useState(false);
    const [editSaveLoading, setEditSaveLoading] = useState(false);
    const [editSaveSuccess, setEditSaveSuccess] = useState(false);
    const [editError, setEditError] = useState('');

    // Reports Tournament Selector Modal
    const [showReportsTournamentModal, setShowReportsTournamentModal] = useState(false);
    const [reportsTournaments, setReportsTournaments] = useState<any[]>([]);
    const [reportsTournamentsLoading, setReportsTournamentsLoading] = useState(false);

    useEffect(() => {
        const loggedInAdminStr = localStorage.getItem('loggedInAdmin');
        if (!loggedInAdminStr) {
            navigate('/admin');
            return;
        }

        try {
            const adminData = JSON.parse(loggedInAdminStr);
            setAdmin(adminData);
        } catch (err) {
            console.error('Error parsing admin data:', err);
            navigate('/admin');
            return;
        }

        setLoading(false);

        // Load password count for header
        fetch(`${BACKEND_URL}/api/admin/bowlers-with-password-count`)
            .then(r => r.json())
            .then(data => setWithPasswordCount(data.count ?? null))
            .catch(() => { /* non-critical */ });
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('loggedInAdmin');
        navigate('/admin');
    };

    const loadRecruiterBalances = async () => {
        setRecruiterBalancesLoading(true);
        setRecruiterBalancesError('');
        try {
            const response = await fetch(`${BACKEND_URL}/api/admin/recruiter-balances`);
            const data = await response.json();
            setRecruiterBalances(data || []);
        } catch {
            setRecruiterBalancesError('Failed to load recruiter balances.');
        } finally {
            setRecruiterBalancesLoading(false);
        }
    };

    const loadAllRecruiters = async () => {
        setAllRecruitersLoading(true);
        try {
            const r = await fetch(`${BACKEND_URL}/api/admin/all-recruiters`);
            const data = await r.json();
            setAllRecruiters(data || []);
        } catch {
            setAllRecruiters([]);
        } finally {
            setAllRecruitersLoading(false);
        }
    };

    const loadRosterTournaments = async (recruiterClave: number) => {
        setRosterTournamentsLoading(true);
        setRosterTournaments([]);
        setSelectedRosterTournament(null);
        setRosterBowlers([]);
        setRosterSearch('');
        try {
            const r = await fetch(`${BACKEND_URL}/api/recruiter/roster/${recruiterClave}`);
            const data = await r.json();
            setRosterTournaments(data || []);
        } catch {
            setRosterTournaments([]);
        } finally {
            setRosterTournamentsLoading(false);
        }
    };

    const loadRosterBowlers = async (recruiterClave: number, torneoClave: number) => {
        setRosterBowlersLoading(true);
        setRosterBowlers([]);
        setRosterSearch('');
        try {
            const r = await fetch(`${BACKEND_URL}/api/recruiter/roster/${recruiterClave}/${torneoClave}`);
            const data = await r.json();
            setRosterBowlers(data || []);
        } catch {
            setRosterBowlers([]);
        } finally {
            setRosterBowlersLoading(false);
        }
    };

    // Load bowlers for reset password modal
    const loadBowlersForReset = async () => {
        try {
            const response = await fetch(`${BACKEND_URL}/api/admin/bowlers`);
            const data = await response.json();
            setBowlers(data);
            setFilteredBowlers(data);
        } catch (error) {
            console.error('Error loading bowlers:', error);
        }
    };

    // Load bowlers for set password modal
    const loadBowlersForSetPassword = async () => {
        try {
            const response = await fetch(`${BACKEND_URL}/api/admin/bowlers`);
            const data = await response.json();
            setSetPasswordBowlers(data);
            setFilteredPasswordBowlers(data);
        } catch (error) {
            console.error('Error loading bowlers:', error);
        }
    };

    const loadReportsTournaments = async () => {
        setReportsTournamentsLoading(true);
        try {
            const res = await fetch(`${BACKEND_URL}/tournaments/all-for-results`);
            const data = await res.json();
            setReportsTournaments(Array.isArray(data) ? data : []);
        } catch {
            setReportsTournaments([]);
        } finally {
            setReportsTournamentsLoading(false);
        }
    };

    // Handle search for reset password
    useEffect(() => {
        let filtered = bowlers;

        // Apply no-email filter if toggled
        if (showOnlyNoEmail) {
            filtered = filtered.filter(b => !b.EMAIL || b.EMAIL.trim() === '');
        }

        // Apply search term filter
        if (searchTerm !== '') {
            filtered = filtered.filter(b =>
                b.FICHANAL.toString().includes(searchTerm) ||
                (b.NOMBRECOMPLETO && b.NOMBRECOMPLETO.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (b.EMAIL && b.EMAIL.toLowerCase().includes(searchTerm.toLowerCase()))
            );
        }

        setFilteredBowlers(filtered);
    }, [searchTerm, bowlers, showOnlyNoEmail]);

    // Handle search for set password
    useEffect(() => {
        if (passwordSearchTerm === '') {
            setFilteredPasswordBowlers(setPasswordBowlers);
        } else {
            const filtered = setPasswordBowlers.filter(b =>
                b.FICHANAL.toString().includes(passwordSearchTerm) ||
                (b.NOMBRECOMPLETO && b.NOMBRECOMPLETO.toLowerCase().includes(passwordSearchTerm.toLowerCase())) ||
                (b.EMAIL && b.EMAIL.toLowerCase().includes(passwordSearchTerm.toLowerCase()))
            );
            setFilteredPasswordBowlers(filtered);
        }
    }, [passwordSearchTerm, setPasswordBowlers]);

    // Handle search for edit bowler
    useEffect(() => {
        if (editBowlerSearch === '') {
            setFilteredEditBowlers(editBowlerList);
        } else {
            const term = editBowlerSearch.toLowerCase();
            setFilteredEditBowlers(editBowlerList.filter(b => {
                const displayName = (b.NOMBRECOMPLETO || `${b.NOMBRE || ''} ${b.APELLIDOP || ''}`).toLowerCase().trim();
                return (
                    b.FICHANAL.toString().includes(editBowlerSearch) ||
                    displayName.includes(term) ||
                    (b.EMAIL && b.EMAIL.toLowerCase().includes(term))
                );
            }));
        }
    }, [editBowlerSearch, editBowlerList]);

    const handleSelectBowler = (email: string) => {
        const newSelected = new Set(selectedBowlers);
        if (newSelected.has(email)) {
            newSelected.delete(email);
        } else {
            newSelected.add(email);
        }
        setSelectedBowlers(newSelected);
    };

    const handleSelectAll = () => {
        // Filter out bowlers with null/undefined emails
        const validEmailBowlers = filteredBowlers.filter(b => b.EMAIL);
        const validEmails = validEmailBowlers.map(b => b.EMAIL);

        // Check if all valid emails are selected
        const allSelected = validEmails.every(email => selectedBowlers.has(email));

        if (allSelected) {
            setSelectedBowlers(new Set());
        } else {
            setSelectedBowlers(new Set(validEmails));
        }
    };

    const handleSelectAllWithoutPasswords = () => {
        // Filter bowlers with emails but no passwords (CONTRASENA is null)
        const bowlersWithoutPasswords = filteredBowlers.filter(b => b.EMAIL && (!b.CONTRASENA || b.CONTRASENA === ''));
        const emails = bowlersWithoutPasswords.map(b => b.EMAIL);

        // Check if all are already selected
        const allSelected = emails.every(email => selectedBowlers.has(email));

        if (allSelected) {
            // Deselect only those without passwords
            const newSelected = new Set(selectedBowlers);
            emails.forEach(email => newSelected.delete(email));
            setSelectedBowlers(newSelected);
        } else {
            // Add all without passwords to selection
            const newSelected = new Set(selectedBowlers);
            emails.forEach(email => newSelected.add(email));
            setSelectedBowlers(newSelected);
        }
    };

    const handleExportNoEmail = () => {
        // Get all bowlers without email from the full bowlers list
        const bowlersWithoutEmail = bowlers.filter(b => !b.EMAIL || b.EMAIL.trim() === '');
        
        if (bowlersWithoutEmail.length === 0) {
            alert('No bowlers without email found.');
            return;
        }

        // Create CSV content
        const headers = ['TAT ID', 'Name', 'City'];
        const csvRows = [headers.join(',')];

        bowlersWithoutEmail.forEach(bowler => {
            const row = [
                bowler.FICHANAL,
                `"${(bowler.NOMBRECOMPLETO || 'N/A').replace(/"/g, '""')}"`,
                `"${(bowler.CITY || 'N/A').replace(/"/g, '""')}"`
            ];
            csvRows.push(row.join(','));
        });

        const csvContent = csvRows.join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        link.setAttribute('href', url);
        link.setAttribute('download', `bowlers-without-email-${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log(`✅ Exported ${bowlersWithoutEmail.length} bowlers without email`);
    };

    const handleSendResetEmails = async () => {
        if (selectedBowlers.size === 0) return;

        setResetLoading(true);
        setResetError('');
        cancelRequested.current = false;
        
        const emailsArray = Array.from(selectedBowlers);
        const BATCH_SIZE = 100; // Send 100 emails per batch
        const totalBatches = Math.ceil(emailsArray.length / BATCH_SIZE);
        
        setResetProgress({ current: 0, total: emailsArray.length });

        try {
            let successCount = 0;
            let failCount = 0;

            // Process in batches
            for (let i = 0; i < totalBatches; i++) {
                // Check if cancel was requested
                if (cancelRequested.current) {
                    setResetError(`Cancelled. Sent ${successCount} out of ${emailsArray.length} emails before stopping.`);
                    break;
                }

                const start = i * BATCH_SIZE;
                const end = Math.min(start + BATCH_SIZE, emailsArray.length);
                const batch = emailsArray.slice(start, end);

                try {
                    const response = await fetch(`${BACKEND_URL}/api/admin/bulk-reset-password`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ emails: batch })
                    });

                    const data = await response.json();

                    if (response.ok && data.success) {
                        successCount += data.sent || batch.length;
                    } else {
                        failCount += batch.length;
                    }
                } catch (batchError) {
                    console.error(`Error sending batch ${i + 1}:`, batchError);
                    failCount += batch.length;
                }

                // Update progress
                setResetProgress({ current: end, total: emailsArray.length });

                // Small delay between batches to avoid overwhelming the server
                if (i < totalBatches - 1) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                }
            }

            // Only show success if not cancelled
            if (!cancelRequested.current) {
                if (failCount > 0) {
                    setResetError(`Sent ${successCount} emails successfully. ${failCount} failed.`);
                } else {
                    setResetSuccess(true);
                    setTimeout(() => {
                        setShowResetModal(false);
                        setResetSuccess(false);
                        setSelectedBowlers(new Set());
                        setSearchTerm('');
                        setShowOnlyNoEmail(false);
                        setResetProgress({ current: 0, total: 0 });
                    }, 2000);
                }
            }
        } catch (error) {
            console.error('Error sending reset emails:', error);
            setResetError('An error occurred. Please try again.');
        } finally {
            setResetLoading(false);
            cancelRequested.current = false;
        }
    };

    const handleCancelSending = () => {
        cancelRequested.current = true;
    };

    // Load bowlers for edit modal
    const loadBowlersForEdit = async () => {
        try {
            const response = await fetch(`${BACKEND_URL}/api/admin/bowlers`);
            const data = await response.json();
            setEditBowlerList(data);
            setFilteredEditBowlers(data);
        } catch (error) {
            console.error('Error loading bowlers for edit:', error);
        }
    };

    // Fetch full bowler record and open edit form
    const handleOpenEditForm = async (clave: number) => {
        setEditFetchLoading(true);
        setEditError('');
        try {
            const res = await fetch(`${BACKEND_URL}/api/admin/bowler/${clave}`);
            const data = await res.json();
            if (res.ok) {
                // Format date for HTML date input
                const raw = data.FECHANAC;
                let fechanac = '';
                if (raw) {
                    try { fechanac = new Date(raw).toISOString().split('T')[0]; } catch {}
                }
                setEditBowlerData(data);
                setEditForm({ ...data, FECHANAC: fechanac });
            } else {
                setEditError(data.error || 'Failed to load bowler data');
            }
        } catch {
            setEditError('Failed to load bowler data');
        } finally {
            setEditFetchLoading(false);
        }
    };

    // Save edited bowler data
    const handleSaveEdit = async () => {
        if (!editBowlerData) return;
        setEditSaveLoading(true);
        setEditError('');
        try {
            const res = await fetch(`${BACKEND_URL}/api/admin/bowler/${editBowlerData.CLAVE}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(editForm),
            });
            const data = await res.json();
            if (res.ok && data.success) {
                setEditSaveSuccess(true);
                loadBowlersForEdit();
                setTimeout(() => {
                    setEditSaveSuccess(false);
                    setEditBowlerData(null);
                    setEditForm({});
                }, 2000);
            } else {
                setEditError(data.error || 'Failed to save changes');
            }
        } catch {
            setEditError('An error occurred. Please try again.');
        } finally {
            setEditSaveLoading(false);
        }
    };

    // Password validation
    const validatePassword = (password: string) => {
        return {
            minLength: password.length >= 8,
            hasUppercase: /[A-Z]/.test(password),
            hasLowercase: /[a-z]/.test(password),
            hasNumber: /[0-9]/.test(password),
            hasSymbol: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
            noSpaces: !/[\s\t]/.test(password)
        };
    };

    const validation = validatePassword(newPassword);
    const isValidPassword = Object.values(validation).every(v => v === true);

    const handleSetPassword = async () => {
        if (!selectedBowlerEmail || !newPassword || !isValidPassword) return;

        setSetPasswordLoading(true);
        setSetPasswordError('');

        try {
            const response = await fetch(`${BACKEND_URL}/api/admin/set-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: selectedBowlerEmail, password: newPassword })
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setSetPasswordSuccess(true);
                setTimeout(() => {
                    setShowSetPasswordModal(false);
                    setSetPasswordSuccess(false);
                    setSelectedBowlerEmail('');
                    setNewPassword('');
                    setPasswordSearchTerm('');
                }, 2000);
            } else {
                setSetPasswordError(data.error || 'Failed to set password. Please try again.');
            }
        } catch (error) {
            console.error('Error setting password:', error);
            setSetPasswordError('An error occurred. Please try again.');
        } finally {
            setSetPasswordLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50 to-indigo-100 flex items-center justify-center">
                <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-purple-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50 to-indigo-100">
            {/* Header */}
            <div className="bg-white shadow-lg">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <img
                                src="/logo.avif"
                                alt="True Amateur Tournaments"
                                className="h-12 w-auto"
                            />
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
                                <p className="text-sm text-gray-600">Welcome back, {admin?.NOMBRE}</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            {withPasswordCount !== null && (
                                <div className="text-right">
                                    <p className="text-xs text-gray-400 uppercase tracking-wide font-medium">Logged in bowlers</p>
                                    <p className="text-2xl font-bold text-indigo-600">{withPasswordCount.toLocaleString()}</p>
                                </div>
                            )}
                            <button
                                onClick={handleLogout}
                                className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-medium transition flex items-center gap-2"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                </svg>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Dashboard Cards */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {/* Card 1+2: Passwords (merged) */}
                    <div className="bg-white rounded-2xl shadow-xl p-8">
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-purple-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Passwords</h2>
                        </div>
                        <p className="text-gray-600 mb-5">Send reset links or manually set passwords for bowlers</p>
                        <div className="flex flex-col gap-3">
                            <button
                                onClick={() => { setShowResetModal(true); loadBowlersForReset(); }}
                                className="w-full flex items-center gap-3 bg-blue-50 hover:bg-blue-100 border-2 border-blue-200 hover:border-blue-400 text-blue-800 font-semibold px-4 py-3 rounded-xl transition-all text-left"
                            >
                                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                Send Reset Password Email
                            </button>
                            <button
                                onClick={() => { setShowSetPasswordModal(true); loadBowlersForSetPassword(); }}
                                className="w-full flex items-center gap-3 bg-indigo-50 hover:bg-indigo-100 border-2 border-indigo-200 hover:border-indigo-400 text-indigo-800 font-semibold px-4 py-3 rounded-xl transition-all text-left"
                            >
                                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                </svg>
                                Set Password Manually
                            </button>
                        </div>
                    </div>

                    {/* Card 3: Edit Bowler Info */}
                    <div
                        onClick={() => {
                            setShowEditBowlerModal(true);
                            loadBowlersForEdit();
                        }}
                        className="bg-white rounded-2xl shadow-xl p-8 cursor-pointer hover:shadow-2xl transition-all transform hover:-translate-y-1"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-purple-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Edit Bowler Info</h2>
                        </div>
                        <p className="text-gray-600">View and update bowler profile details</p>
                    </div>

                    {/* Card 4: Tournament Entries */}
                    <div
                        onClick={() => navigate('/admin/tournament-entries')}
                        className="bg-white rounded-2xl shadow-xl p-8 cursor-pointer hover:shadow-2xl transition-all transform hover:-translate-y-1"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-green-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Tournament Entries</h2>
                        </div>
                        <p className="text-gray-600">View bowlers, packages, and balances per tournament</p>
                    </div>

                    {/* Card 5+6: Recruiters (merged) */}
                    <div className="bg-white rounded-2xl shadow-xl p-8">
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-red-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Recruiters</h2>
                        </div>
                        <p className="text-gray-600 mb-5">View recruiter rosters and unpaid platform fee balances</p>
                        <div className="flex flex-col gap-3">
                            <button
                                onClick={() => { setShowRecruiterRostersModal(true); loadAllRecruiters(); }}
                                className="w-full flex items-center gap-3 bg-yellow-50 hover:bg-yellow-100 border-2 border-yellow-200 hover:border-yellow-400 text-yellow-800 font-semibold px-4 py-3 rounded-xl transition-all text-left"
                            >
                                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2M9 12h6m-6 4h6" />
                                </svg>
                                Recruiter Rosters
                            </button>
                            <button
                                onClick={() => { setShowRecruiterBalancesModal(true); loadRecruiterBalances(); }}
                                className="w-full flex items-center gap-3 bg-red-50 hover:bg-red-100 border-2 border-red-200 hover:border-red-400 text-red-800 font-semibold px-4 py-3 rounded-xl transition-all text-left"
                            >
                                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Recruiter Balances
                            </button>
                        </div>
                    </div>

                    {/* Card 7: Move Bowler's Squads — hidden, not removed */}
                    {/* <div
                        onClick={() => navigate('/admin/move-squads')}
                        className="bg-white rounded-2xl shadow-xl p-8 cursor-pointer hover:shadow-2xl transition-all transform hover:-translate-y-1"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-indigo-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Move Bowler's Squads</h2>
                        </div>
                        <p className="text-gray-600">Reschedule squad assignments for any bowler on their behalf</p>
                    </div> */}

                    {/* Card: Bowler History */}
                    <div
                        onClick={() => navigate('/admin/bowler-history')}
                        className="bg-white rounded-2xl shadow-xl p-8 cursor-pointer hover:shadow-2xl transition-all transform hover:-translate-y-1"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-green-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Bowler History</h2>
                        </div>
                        <p className="text-gray-600">View any bowler's full tournament history, packages, and scores</p>
                    </div>

                    {/* Card 8: Manage Teams */}
                    <div
                        onClick={() => navigate('/admin/manage-teams')}
                        className="bg-white rounded-2xl shadow-xl p-8 cursor-pointer hover:shadow-2xl transition-all transform hover:-translate-y-1"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-pink-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Manage Teams</h2>
                        </div>
                        <p className="text-gray-600">View, create, and edit all teams for any tournament's team event</p>
                    </div>

                

                    {/* Card: Web Fees — only visible to admin CLAVE 28 */}
                    {admin?.CLAVE === 28 && (
                        <div
                            onClick={() => navigate('/admin/web-fees')}
                            className="bg-white rounded-2xl shadow-xl p-8 cursor-pointer hover:shadow-2xl transition-all transform hover:-translate-y-1"
                        >
                            <div className="flex items-center gap-4 mb-4">
                                <div className="bg-yellow-100 rounded-xl p-3">
                                    <svg className="w-8 h-8 text-yellow-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                    </svg>
                                </div>
                                <h2 className="text-xl font-bold text-gray-900">Web Fees</h2>
                            </div>
                            <p className="text-gray-600">Track web registration fee payments, POS collections, and generate invoices</p>
                        </div>
                    )}

                    {/* Card: Tournament Lists */}
                    <div
                        onClick={() => navigate('/admin/tournament-lists')}
                        className="bg-white rounded-2xl shadow-xl p-8 cursor-pointer hover:shadow-2xl transition-all transform hover:-translate-y-1"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-blue-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Tournament Sales Lists</h2>
                        </div>
                        <p className="text-gray-600">View payment and package lists for any tournament</p>
                    </div>

                    {/* Card: Reports */}
                    <div
                        onClick={() => { setShowReportsTournamentModal(true); loadReportsTournaments(); }}
                        className="bg-white rounded-2xl shadow-xl p-8 cursor-pointer hover:shadow-2xl transition-all transform hover:-translate-y-1"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-blue-100 rounded-xl p-3">
                                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900">Reports</h2>
                        </div>
                        <p className="text-gray-600">View tournament reports such as defaulted averages per division</p>
                    </div>
                </div>
            </div>

            {/* Support Tickets */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
                <AdminTickets />
            </div>

            {/* Reset Password Modal */}
            {showResetModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl" style={{ height: '90vh', maxHeight: '90vh' }}>
                        {!resetSuccess ? (
                            <div className="h-full flex flex-col">
                                {/* Modal Header */}
                                <div className="border-b p-6">
                                    <div className="flex items-center justify-between">
                                        <h2 className="text-2xl font-bold text-gray-900">Send Reset Password Emails</h2>
                                        <button
                                            onClick={() => {
                                                setShowResetModal(false);
                                                setSelectedBowlers(new Set());
                                                setSearchTerm('');
                                                setShowOnlyNoEmail(false);
                                                setResetError('');
                                                setResetProgress({ current: 0, total: 0 });
                                            }}
                                            className="text-gray-400 hover:text-gray-600"
                                        >
                                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                {/* Search and Select All */}
                                <div className="p-6 border-b space-y-4">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        placeholder="Search by TAT ID, Name, or Email..."
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <div className="flex items-center justify-between flex-wrap gap-2">
                                        <div className="flex gap-3">
                                            <button
                                                onClick={handleSelectAll}
                                                className="text-blue-600 hover:text-blue-800 font-medium"
                                            >
                                                {(() => {
                                                    const validEmails = filteredBowlers.filter(b => b.EMAIL).map(b => b.EMAIL);
                                                    const allSelected = validEmails.every(email => selectedBowlers.has(email));
                                                    return allSelected && validEmails.length > 0 ? 'Deselect All' : 'Select All';
                                                })()}
                                            </button>
                                            <button
                                                onClick={handleSelectAllWithoutPasswords}
                                                className="text-purple-600 hover:text-purple-800 font-medium"
                                            >
                                                {(() => {
                                                    const bowlersWithoutPasswords = filteredBowlers.filter(b => b.EMAIL && (!b.CONTRASENA || b.CONTRASENA === ''));
                                                    const emails = bowlersWithoutPasswords.map(b => b.EMAIL);
                                                    const allSelected = emails.every(email => selectedBowlers.has(email));
                                                    return allSelected && emails.length > 0 ? 'Deselect No Pwd' : 'Select All Without Pwd';
                                                })()}
                                            </button>
                                            <button
                                                onClick={() => setShowOnlyNoEmail(!showOnlyNoEmail)}
                                                className={`font-medium transition ${showOnlyNoEmail ? 'text-orange-600 hover:text-orange-800' : 'text-gray-600 hover:text-gray-800'}`}
                                            >
                                                {showOnlyNoEmail ? '✓ No Email Only' : 'Show No Email'}
                                            </button>
                                            {showOnlyNoEmail && (
                                                <button
                                                    onClick={handleExportNoEmail}
                                                    className="flex items-center gap-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-lg text-sm font-medium transition"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                    </svg>
                                                    Export CSV
                                                </button>
                                            )}
                                        </div>
                                        <span className="text-sm text-gray-600">
                                            {selectedBowlers.size} selected
                                        </span>
                                    </div>
                                </div>

                                {/* Bowlers List - Fixed Height Scrollable */}
                                <div className="flex-1 overflow-y-auto p-6" style={{ minHeight: 0 }}>
                                    <div className="space-y-2">
                                        {filteredBowlers.map((bowler) => (
                                            <div
                                                key={bowler.FICHANAL}
                                                onClick={() => handleSelectBowler(bowler.EMAIL)}
                                                className={`p-4 rounded-lg border-2 cursor-pointer transition ${
                                                    selectedBowlers.has(bowler.EMAIL)
                                                        ? 'border-blue-500 bg-blue-50'
                                                        : 'border-gray-200 hover:border-gray-300'
                                                }`}
                                            >
                                                <div className="flex items-center gap-4">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedBowlers.has(bowler.EMAIL)}
                                                        onChange={() => {}}
                                                        className="w-5 h-5"
                                                    />
                                                    <div className="flex-1">
                                                        <div className="flex items-center gap-3">
                                                            <span className="font-bold text-gray-900">TAT #{bowler.FICHANAL}</span>
                                                            <span className="text-gray-900">{bowler.NOMBRECOMPLETO || 'N/A'}</span>
                                                        </div>
                                                        <div className="text-sm text-gray-600 mt-1">
                                                            <span>{bowler.EMAIL || 'No email'}</span>
                                                            {bowler.CITY && (
                                                                <>
                                                                    <span className="mx-2">•</span>
                                                                    <span>{bowler.CITY}</span>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Error Message */}
                                {resetError && (
                                    <div className="px-6 pb-4">
                                        <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                                            {resetError}
                                        </div>
                                    </div>
                                )}

                                {/* Footer */}
                                <div className="border-t p-6">
                                    {resetLoading && resetProgress.total > 0 && (
                                        <div className="mb-4">
                                            <div className="flex justify-between text-sm text-gray-600 mb-2">
                                                <span>Sending emails in batches...</span>
                                                <span>{resetProgress.current} / {resetProgress.total}</span>
                                            </div>
                                            <div className="w-full bg-gray-200 rounded-full h-2">
                                                <div 
                                                    className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                                                    style={{ width: `${(resetProgress.current / resetProgress.total) * 100}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="flex gap-3">
                                        <button
                                            onClick={handleSendResetEmails}
                                            disabled={selectedBowlers.size === 0 || resetLoading}
                                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            {resetLoading ? (
                                                <span className="flex items-center justify-center gap-2">
                                                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                                                    Sending...
                                                </span>
                                            ) : (
                                                `Send Reset Emails (${selectedBowlers.size})`
                                            )}
                                        </button>
                                        {resetLoading && (
                                            <button
                                                onClick={handleCancelSending}
                                                className="px-6 bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg font-semibold transition"
                                            >
                                                Cancel
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="p-12 text-center">
                                <div className="bg-green-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 animate-bounce">
                                    <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-2">Success!</h3>
                                <p className="text-gray-600">Reset password emails sent successfully</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Set Password Modal */}
            {showSetPasswordModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl" style={{ height: '90vh', maxHeight: '90vh' }}>
                        {!setPasswordSuccess ? (
                            <div className="h-full flex flex-col">
                                {/* Modal Header */}
                                <div className="border-b p-6">
                                    <div className="flex items-center justify-between">
                                        <h2 className="text-2xl font-bold text-gray-900">Set Password Manually</h2>
                                        <button
                                            onClick={() => {
                                                setShowSetPasswordModal(false);
                                                setSelectedBowlerEmail('');
                                                setNewPassword('');
                                                setPasswordSearchTerm('');
                                                setSetPasswordError('');
                                            }}
                                            className="text-gray-400 hover:text-gray-600"
                                        >
                                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                {/* Search */}
                                <div className="p-6 border-b">
                                    <input
                                        type="text"
                                        value={passwordSearchTerm}
                                        onChange={(e) => setPasswordSearchTerm(e.target.value)}
                                        placeholder="Search by TAT ID, Name, or Email..."
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                    />
                                </div>

                                {/* Bowlers List - Fixed Height Scrollable */}
                                <div className="flex-1 overflow-y-auto p-6" style={{ minHeight: 0 }}>
                                    <div className="space-y-2">
                                        {filteredPasswordBowlers.map((bowler) => (
                                            <div
                                                key={bowler.FICHANAL}
                                                className={`p-4 rounded-lg border-2 ${
                                                    selectedBowlerEmail === bowler.EMAIL
                                                        ? 'border-green-500 bg-green-50'
                                                        : 'border-gray-200'
                                                }`}
                                            >
                                                <div className="flex items-start gap-4">
                                                    <input
                                                        type="radio"
                                                        name="bowler"
                                                        checked={selectedBowlerEmail === bowler.EMAIL}
                                                        onChange={() => setSelectedBowlerEmail(bowler.EMAIL)}
                                                        className="w-5 h-5 mt-1"
                                                    />
                                                    <div className="flex-1">
                                                        <div className="flex items-center gap-3 mb-2">
                                                            <span className="font-bold text-gray-900">TAT #{bowler.FICHANAL}</span>
                                                            <span className="text-gray-900">{bowler.NOMBRECOMPLETO || 'N/A'}</span>
                                                        </div>
                                                        <div className="text-sm text-gray-600 mb-3">
                                                            <span>{bowler.EMAIL || 'No email'}</span>
                                                            {bowler.CITY && (
                                                                <>
                                                                    <span className="mx-2">•</span>
                                                                    <span>{bowler.CITY}</span>
                                                                </>
                                                            )}
                                                        </div>

                                                        {selectedBowlerEmail === bowler.EMAIL && (
                                                            <div className="mt-3">
                                                                <label className="block text-sm font-bold text-gray-700 mb-2">
                                                                    Set New Password
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    value={newPassword}
                                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                                    placeholder="Enter password (visible for copying)"
                                                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                                                />
                                                                {newPassword && (
                                                                    <div className="mt-2 space-y-1 text-xs">
                                                                        <div className={validation.minLength ? 'text-green-600' : 'text-gray-500'}>
                                                                            {validation.minLength ? '✓' : '○'} At least 8 characters
                                                                        </div>
                                                                        <div className={validation.hasUppercase ? 'text-green-600' : 'text-gray-500'}>
                                                                            {validation.hasUppercase ? '✓' : '○'} One uppercase letter
                                                                        </div>
                                                                        <div className={validation.hasLowercase ? 'text-green-600' : 'text-gray-500'}>
                                                                            {validation.hasLowercase ? '✓' : '○'} One lowercase letter
                                                                        </div>
                                                                        <div className={validation.hasNumber ? 'text-green-600' : 'text-gray-500'}>
                                                                            {validation.hasNumber ? '✓' : '○'} One number
                                                                        </div>
                                                                        <div className={validation.hasSymbol ? 'text-green-600' : 'text-gray-500'}>
                                                                            {validation.hasSymbol ? '✓' : '○'} One symbol
                                                                        </div>
                                                                        <div className={validation.noSpaces ? 'text-green-600' : 'text-gray-500'}>
                                                                            {validation.noSpaces ? '✓' : '○'} No spaces
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Error Message */}
                                {setPasswordError && (
                                    <div className="px-6 pb-4">
                                        <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                                            {setPasswordError}
                                        </div>
                                    </div>
                                )}

                                {/* Footer */}
                                <div className="border-t p-6">
                                    <button
                                        onClick={handleSetPassword}
                                        disabled={!selectedBowlerEmail || !isValidPassword || setPasswordLoading}
                                        className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {setPasswordLoading ? (
                                            <span className="flex items-center justify-center gap-2">
                                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                                                Setting Password...
                                            </span>
                                        ) : (
                                            'Set Password & Send Email'
                                        )}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="p-12 text-center">
                                <div className="bg-green-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 animate-bounce">
                                    <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-2">Success!</h3>
                                <p className="text-gray-600">Password set and notification email sent successfully</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Recruiter Balances Modal */}
            {showRecruiterBalancesModal && (() => {
                // Group rows by recruiter
                const recruiterMap: Record<number, { name: string; tat: number; tournaments: any[] }> = {};
                for (const row of recruiterBalances) {
                    if (!recruiterMap[row.RECRUITER_CLAVE]) {
                        recruiterMap[row.RECRUITER_CLAVE] = { name: row.RECRUITER_NAME, tat: row.RECRUITER_TAT, tournaments: [] };
                    }
                    recruiterMap[row.RECRUITER_CLAVE].tournaments.push(row);
                }
                const recruiters = Object.entries(recruiterMap).map(([clave, data]) => ({ clave: Number(clave), ...data }));
                const grandTotal = recruiterBalances.reduce((s, r) => s + (isFeeApplicable(r.FECHAINICIO) ? (r.UNPAID_COUNT || 0) * 10 : 0), 0);

                return (
                    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl" style={{ height: '90vh', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                            {/* Header */}
                            <div className="border-b p-6 flex items-center justify-between flex-shrink-0">
                                <div>
                                    <h2 className="text-2xl font-bold text-gray-900">Recruiter Balances</h2>
                                    {!recruiterBalancesLoading && recruiters.length > 0 && (
                                        <p className="text-sm text-gray-500 mt-0.5">{recruiters.length} recruiter{recruiters.length !== 1 ? 's' : ''} · ${grandTotal} total owed</p>
                                    )}
                                </div>
                                <button
                                    onClick={() => { setShowRecruiterBalancesModal(false); setExpandedRecruiter(null); }}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>

                            {/* Body */}
                            <div className="flex-1 overflow-y-auto p-6" style={{ minHeight: 0 }}>
                                {recruiterBalancesLoading && (
                                    <div className="flex items-center justify-center py-16">
                                        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600" />
                                    </div>
                                )}
                                {recruiterBalancesError && (
                                    <div className="text-red-500 text-center py-10">{recruiterBalancesError}</div>
                                )}
                                {!recruiterBalancesLoading && !recruiterBalancesError && recruiters.length === 0 && (
                                    <div className="text-gray-500 text-center py-10">No recruiter data found.</div>
                                )}
                                <div className="space-y-3">
                                    {recruiters.map(rec => {
                                        const totalBowlers = rec.tournaments.reduce((s: number, t: any) => s + (t.BOWLER_COUNT || 0), 0);
                                        const totalUnpaid = rec.tournaments.reduce((s: number, t: any) => s + (isFeeApplicable(t.FECHAINICIO) ? (t.UNPAID_COUNT || 0) : 0), 0);
                                        const isExpanded = expandedRecruiter === rec.clave;
                                        return (
                                            <div key={rec.clave} className="border border-gray-200 rounded-xl overflow-hidden">
                                                <button
                                                    onClick={() => setExpandedRecruiter(isExpanded ? null : rec.clave)}
                                                    className="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition text-left"
                                                >
                                                    <div>
                                                        <p className="font-semibold text-gray-900">{rec.name}</p>
                                                        <p className="text-xs text-gray-500">TAT# {rec.tat} · {totalBowlers} bowler{totalBowlers !== 1 ? 's' : ''}</p>
                                                    </div>
                                                    <div className="flex items-center gap-3">
                                                        {totalUnpaid > 0 ? (
                                                            <span className="bg-amber-100 text-amber-700 text-sm font-bold px-3 py-1 rounded-full">${totalUnpaid * 10} owed</span>
                                                        ) : (
                                                            <span className="bg-green-100 text-green-700 text-sm font-semibold px-3 py-1 rounded-full">All paid</span>
                                                        )}
                                                        <svg className={`w-4 h-4 text-gray-400 transition-transform ${isExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                        </svg>
                                                    </div>
                                                </button>
                                                {isExpanded && (
                                                    <div className="border-t border-gray-100 divide-y divide-gray-100">
                                                        {rec.tournaments.map((t: any) => (
                                                            <div
                                                                key={t.TORNEO_CLAVE}
                                                                className={`px-4 py-3 flex items-center justify-between bg-gray-50 ${isFeeApplicable(t.FECHAINICIO) && t.UNPAID_COUNT > 0 ? 'cursor-pointer hover:bg-amber-50 transition' : ''}`}
                                                                onClick={() => isFeeApplicable(t.FECHAINICIO) && t.UNPAID_COUNT > 0 && navigate(`/admin/recruiter-roster/${rec.clave}/${t.TORNEO_CLAVE}`)}
                                                            >
                                                                <div>
                                                                    <p className="text-sm font-medium text-gray-800">{t.TORNEO_NOMBRE}</p>
                                                                    <p className="text-xs text-gray-500">{t.BOWLER_COUNT} bowler{t.BOWLER_COUNT !== 1 ? 's' : ''}</p>
                                                                </div>
                                                                {!isFeeApplicable(t.FECHAINICIO) ? (
                                                                    <span className="bg-gray-100 text-gray-400 text-xs font-semibold px-2 py-0.5 rounded-full">No fee</span>
                                                                ) : t.UNPAID_COUNT > 0 ? (
                                                                    <span className="bg-amber-100 text-amber-700 text-xs font-bold px-2 py-0.5 rounded-full flex items-center gap-1">
                                                                        ${t.UNPAID_COUNT * 10} owed
                                                                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                                        </svg>
                                                                    </span>
                                                                ) : (
                                                                    <span className="bg-green-100 text-green-700 text-xs font-semibold px-2 py-0.5 rounded-full">Paid</span>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Recruiter Rosters Modal */}
            {showRecruiterRostersModal && (() => {
                const filteredBowlers = rosterBowlers.filter(b => {
                    if (!rosterSearch) return true;
                    const s = rosterSearch.toLowerCase();
                    return (
                        b.nombreCompleto?.toLowerCase().includes(s) ||
                        String(b.fichanal).includes(s) ||
                        b.email?.toLowerCase().includes(s)
                    );
                });
                return (
                    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl" style={{ height: '90vh', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                            {/* Header */}
                            <div className="border-b p-6 flex items-center justify-between flex-shrink-0">
                                <div>
                                    <h2 className="text-2xl font-bold text-gray-900">Recruiter Rosters</h2>
                                    {selectedRosterRecruiter && (
                                        <p className="text-sm text-gray-500 mt-0.5">{selectedRosterRecruiter.NOMBRECOMPLETO}</p>
                                    )}
                                </div>
                                <button
                                    onClick={() => {
                                        setShowRecruiterRostersModal(false);
                                        setSelectedRosterRecruiter(null);
                                        setRosterTournaments([]);
                                        setSelectedRosterTournament(null);
                                        setRosterBowlers([]);
                                        setRosterSearch('');
                                    }}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>

                            {/* Body — 3 columns */}
                            <div className="flex-1 flex overflow-hidden min-h-0">
                                {/* Col 1: Recruiters */}
                                <div className="w-56 border-r flex-shrink-0 overflow-y-auto">
                                    <div className="px-3 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wide border-b">Recruiter</div>
                                    {allRecruitersLoading ? (
                                        <div className="flex justify-center py-6">
                                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-teal-500" />
                                        </div>
                                    ) : allRecruiters.length === 0 ? (
                                        <div className="px-3 py-4 text-xs text-gray-400">No recruiters found.</div>
                                    ) : (
                                        allRecruiters.map((rec: any) => (
                                            <button
                                                key={rec.CVEJUGADOR}
                                                onClick={() => { setSelectedRosterRecruiter(rec); loadRosterTournaments(rec.CVEJUGADOR); }}
                                                className={`w-full text-left px-3 py-2.5 text-sm transition ${selectedRosterRecruiter?.CVEJUGADOR === rec.CVEJUGADOR ? 'bg-teal-50 text-teal-800 font-semibold' : 'hover:bg-gray-50 text-gray-800'}`}
                                            >
                                                <div className="font-medium leading-tight">{rec.NOMBRECOMPLETO}</div>
                                                <div className="text-xs text-gray-400">TAT #{rec.FICHANAL}</div>
                                            </button>
                                        ))
                                    )}
                                </div>

                                {/* Col 2: Tournaments */}
                                <div className="w-60 border-r flex-shrink-0 overflow-y-auto">
                                    <div className="px-3 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wide border-b">Tournament</div>
                                    {!selectedRosterRecruiter ? (
                                        <div className="px-3 py-4 text-xs text-gray-400">Select a recruiter</div>
                                    ) : rosterTournamentsLoading ? (
                                        <div className="flex justify-center py-6">
                                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-teal-500" />
                                        </div>
                                    ) : rosterTournaments.length === 0 ? (
                                        <div className="px-3 py-4 text-xs text-gray-400">No tournaments found.</div>
                                    ) : (
                                        rosterTournaments.map((t: any) => (
                                            <button
                                                key={t.torneoClave}
                                                onClick={() => { setSelectedRosterTournament(t); loadRosterBowlers(selectedRosterRecruiter.CVEJUGADOR, t.torneoClave); }}
                                                className={`w-full text-left px-3 py-2.5 text-sm transition ${selectedRosterTournament?.torneoClave === t.torneoClave ? 'bg-teal-50 text-teal-800 font-semibold' : 'hover:bg-gray-50 text-gray-800'}`}
                                            >
                                                <div className="font-medium leading-tight">{t.torneoNombre}</div>
                                                <div className="text-xs text-gray-400 mt-0.5">
                                                    {t.bowlerCount} bowler{t.bowlerCount !== 1 ? 's' : ''}
                                                    {isFeeApplicable(t.fechaInicio) && t.unpaidCount > 0 && <span className="ml-1 text-amber-600 font-semibold">· {t.unpaidCount} owed</span>}
                                                </div>
                                            </button>
                                        ))
                                    )}
                                </div>

                                {/* Col 3: Bowler list */}
                                <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                                    <div className="px-3 py-2 border-b flex-shrink-0">
                                        {selectedRosterTournament ? (
                                            <input
                                                type="text"
                                                value={rosterSearch}
                                                onChange={e => setRosterSearch(e.target.value)}
                                                placeholder="Search bowlers…"
                                                className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                                            />
                                        ) : (
                                            <span className="text-xs font-semibold text-gray-400 uppercase tracking-wide">Bowlers</span>
                                        )}
                                    </div>
                                    <div className="flex-1 overflow-y-auto">
                                        {!selectedRosterTournament ? (
                                            <div className="px-3 py-4 text-xs text-gray-400">Select a tournament</div>
                                        ) : rosterBowlersLoading ? (
                                            <div className="flex justify-center py-6">
                                                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-teal-500" />
                                            </div>
                                        ) : filteredBowlers.length === 0 ? (
                                            <div className="px-3 py-4 text-xs text-gray-400">{rosterSearch ? 'No matches.' : 'No bowlers found.'}</div>
                                        ) : (
                                            <div className="divide-y divide-gray-100">
                                                {filteredBowlers.map((b: any) => (
                                                    <div key={b.clave} className="px-4 py-2.5 flex items-center justify-between gap-3">
                                                        <div>
                                                            <div className="flex items-center gap-2">
                                                                <span className="text-xs font-bold text-gray-500">#{b.fichanal}</span>
                                                                <span className="text-sm font-medium text-gray-900">{b.nombreCompleto}</span>
                                                            </div>
                                                            <div className="text-xs text-gray-400">{b.email || 'No email'}</div>
                                                        </div>
                                                        {(!b.webfee || b.webfee !== 1) && isFeeApplicable(selectedRosterTournament?.fechaInicio) ? (
                                                            <span className="flex-shrink-0 text-xs font-semibold px-2 py-0.5 rounded-full bg-red-100 text-red-700">Owes</span>
                                                        ) : b.webfee === 1 && isFeeApplicable(selectedRosterTournament?.fechaInicio) ? (
                                                            <span className="flex-shrink-0 text-xs font-semibold px-2 py-0.5 rounded-full bg-green-100 text-green-700">Paid Platform Fee</span>
                                                        ) : null}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Edit Bowler Info Modal */}
            {showEditBowlerModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl" style={{ height: '90vh', maxHeight: '90vh' }}>
                        <div className="h-full flex flex-col">

                            {/* Modal Header */}
                            <div className="border-b p-6">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        {editBowlerData && !editFetchLoading && (
                                            <button
                                                onClick={() => { setEditBowlerData(null); setEditForm({}); setEditError(''); setEditSaveSuccess(false); }}
                                                className="text-gray-400 hover:text-gray-700 p-1 rounded-lg hover:bg-gray-100 transition mr-1"
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                                </svg>
                                            </button>
                                        )}
                                        <div>
                                            <h2 className="text-2xl font-bold text-gray-900">
                                                {editBowlerData ? `Editing: ${editBowlerData.NOMBRECOMPLETO || 'Bowler'}` : 'Edit Bowler Info'}
                                            </h2>
                                            {editBowlerData && (
                                                <p className="text-sm text-gray-500">TAT #{editBowlerData.FICHANAL} &middot; ID {editBowlerData.CLAVE}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => {
                                            setShowEditBowlerModal(false);
                                            setEditBowlerData(null);
                                            setEditForm({});
                                            setEditBowlerSearch('');
                                            setEditError('');
                                            setEditSaveSuccess(false);
                                        }}
                                        className="text-gray-400 hover:text-gray-600"
                                    >
                                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            {/* Body */}
                            {editFetchLoading ? (
                                <div className="flex-1 flex items-center justify-center">
                                    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600" />
                                </div>
                            ) : editBowlerData ? (
                                /* Edit Form View */
                                editSaveSuccess ? (
                                    <div className="p-12 text-center">
                                        <div className="bg-green-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 animate-bounce">
                                            <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                        <h3 className="text-2xl font-bold text-gray-900 mb-2">Saved!</h3>
                                        <p className="text-gray-600">Bowler information updated successfully</p>
                                    </div>
                                ) : (
                                    <>
                                        <div className="flex-1 overflow-y-auto p-6 space-y-4" style={{ minHeight: 0 }}>
                                            {/* Personal Info */}
                                            <div className="bg-slate-50 rounded-xl p-4 space-y-3">
                                                <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest">Personal Info</h3>
                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">First Name *</label>
                                                        <input type="text" value={editForm.NOMBRE || ''} onChange={e => setEditForm((p: any) => ({ ...p, NOMBRE: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Last Name *</label>
                                                        <input type="text" value={editForm.APELLIDOP || ''} onChange={e => setEditForm((p: any) => ({ ...p, APELLIDOP: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Middle Name</label>
                                                        <input type="text" value={editForm.MIDDLENAME || ''} onChange={e => setEditForm((p: any) => ({ ...p, MIDDLENAME: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Suffix</label>
                                                        <input type="text" value={editForm.SUFIJO || ''} onChange={e => setEditForm((p: any) => ({ ...p, SUFIJO: e.target.value }))}
                                                            placeholder="Jr, Sr, III..."
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Nickname</label>
                                                        <input type="text" value={editForm.APODO || ''} onChange={e => setEditForm((p: any) => ({ ...p, APODO: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Date of Birth</label>
                                                        <input type="date" value={editForm.FECHANAC || ''} onChange={e => setEditForm((p: any) => ({ ...p, FECHANAC: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Gender</label>
                                                        <select value={editForm.SEXO || ''} onChange={e => setEditForm((p: any) => ({ ...p, SEXO: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white">
                                                            <option value="">Select...</option>
                                                            <option value="M">Male</option>
                                                            <option value="F">Female</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Contact */}
                                            <div className="bg-slate-50 rounded-xl p-4 space-y-3">
                                                <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest">Contact</h3>
                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Email *</label>
                                                        <input type="email" value={editForm.EMAIL || ''} onChange={e => setEditForm((p: any) => ({ ...p, EMAIL: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Phone</label>
                                                        <input type="tel" value={editForm.TELEFONO || ''} onChange={e => setEditForm((p: any) => ({ ...p, TELEFONO: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Address */}
                                            <div className="bg-slate-50 rounded-xl p-4 space-y-3">
                                                <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest">Address</h3>
                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                    <div className="sm:col-span-2">
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Street</label>
                                                        <input type="text" value={editForm.CALLE || ''} onChange={e => setEditForm((p: any) => ({ ...p, CALLE: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">City</label>
                                                        <input type="text" value={editForm.CITY || ''} onChange={e => setEditForm((p: any) => ({ ...p, CITY: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">ZIP</label>
                                                        <input type="text" value={editForm.ZIP || ''} onChange={e => setEditForm((p: any) => ({ ...p, ZIP: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Country</label>
                                                        <select
                                                            value={String(editForm.CVEPAIS || '')}
                                                            onChange={e => setEditForm((p: any) => ({ ...p, CVEPAIS: Number(e.target.value) || null, CVEESTADO: null }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white"
                                                        >
                                                            <option value="">Select Country</option>
                                                            {COUNTRIES.map(c => (
                                                                <option key={c.id} value={String(c.id)}>{c.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">State / Province</label>
                                                        <select
                                                            value={String(editForm.CVEESTADO || '')}
                                                            onChange={e => setEditForm((p: any) => ({ ...p, CVEESTADO: Number(e.target.value) || null }))}
                                                            disabled={!editForm.CVEPAIS}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed"
                                                        >
                                                            <option value="">Select State</option>
                                                            {editForm.CVEPAIS === 1 && MEXICAN_STATES.map(s => (
                                                                <option key={s.id} value={String(s.id)}>{s.name}</option>
                                                            ))}
                                                            {editForm.CVEPAIS === 2 && US_STATES.map(s => (
                                                                <option key={s.id} value={String(s.id)}>{s.code} – {s.name}</option>
                                                            ))}
                                                            {editForm.CVEPAIS && editForm.CVEPAIS !== 1 && editForm.CVEPAIS !== 2 && (
                                                                <option value={String(getNAStateId(editForm.CVEPAIS) ?? '')}>N/A</option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Bowling Info */}
                                            <div className="bg-slate-50 rounded-xl p-4 space-y-3">
                                                <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest">Bowling Info</h3>
                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">USBC #</label>
                                                        <input type="text" value={editForm.USBCNUM || ''} onChange={e => setEditForm((p: any) => ({ ...p, USBCNUM: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">SSN / Tax ID</label>
                                                        <input type="text" value={editForm.RFC || ''} onChange={e => setEditForm((p: any) => ({ ...p, RFC: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Bowling Hand</label>
                                                        <select value={editForm.MANO || ''} onChange={e => setEditForm((p: any) => ({ ...p, MANO: e.target.value }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white">
                                                            <option value="">Select...</option>
                                                            <option value="R">Right</option>
                                                            <option value="L">Left</option>
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-semibold text-gray-600 mb-1">Player Type</label>
                                                        <select value={String(editForm.TIPOJUGADOR || '')} onChange={e => setEditForm((p: any) => ({ ...p, TIPOJUGADOR: Number(e.target.value) || null }))}
                                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white">
                                                            <option value="">Select Type</option>
                                                            <option value="1">Traditional</option>
                                                            <option value="2">Two Handed</option>
                                                            <option value="3">Chopper</option>
                                                            <option value="4">Backer</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {editError && (
                                            <div className="px-6 pb-2">
                                                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">{editError}</div>
                                            </div>
                                        )}

                                        <div className="border-t p-6 flex gap-3">
                                            <button
                                                onClick={() => { setEditBowlerData(null); setEditForm({}); setEditError(''); }}
                                                className="flex-1 border border-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-50 transition"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={handleSaveEdit}
                                                disabled={editSaveLoading || !editForm.NOMBRE || !editForm.APELLIDOP || !editForm.EMAIL}
                                                className="flex-1 bg-purple-600 hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed text-white py-3 rounded-lg font-semibold transition"
                                            >
                                                {editSaveLoading ? (
                                                    <span className="flex items-center justify-center gap-2">
                                                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
                                                        Saving...
                                                    </span>
                                                ) : 'Save Changes'}
                                            </button>
                                        </div>
                                    </>
                                )
                            ) : (
                                /* Search + List View */
                                <>
                                    <div className="p-6 border-b">
                                        <input
                                            type="text"
                                            value={editBowlerSearch}
                                            onChange={e => setEditBowlerSearch(e.target.value)}
                                            placeholder="Search by TAT ID, Name, or Email..."
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                                        />
                                    </div>
                                    <div className="flex-1 overflow-y-auto p-6" style={{ minHeight: 0 }}>
                                        <div className="space-y-2">
                                            {filteredEditBowlers.map(bowler => (
                                                <div key={bowler.FICHANAL} className="p-4 rounded-lg border-2 border-gray-200 flex items-center justify-between gap-4">
                                                    <div className="min-w-0">
                                                        <div className="flex items-center gap-3 flex-wrap">
                                                            <span className="font-bold text-gray-900">TAT #{bowler.FICHANAL}</span>
                                                            <span className="text-gray-800">{bowler.NOMBRECOMPLETO || `${bowler.NOMBRE || ''} ${bowler.APELLIDOP || ''}`.trim() || 'N/A'}</span>
                                                        </div>
                                                        <p className="text-sm text-gray-500 mt-0.5 truncate">
                                                            {bowler.EMAIL || 'No email'}{bowler.CITY ? ` · ${bowler.CITY}` : ''}
                                                        </p>
                                                    </div>
                                                    <button
                                                        onClick={() => handleOpenEditForm(bowler.CLAVE)}
                                                        className="flex-shrink-0 bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition"
                                                    >
                                                        Edit Details
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Reports — Tournament Selector Modal */}
            {showReportsTournamentModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg">
                        <div className="flex items-center justify-between p-6 border-b">
                            <h2 className="text-xl font-bold text-gray-900">Select Tournament</h2>
                            <button
                                onClick={() => setShowReportsTournamentModal(false)}
                                className="text-gray-400 hover:text-gray-600 transition-colors"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="p-6">
                            <p className="text-gray-500 text-sm mb-4">Choose a tournament to view its reports.</p>
                            {reportsTournamentsLoading ? (
                                <div className="flex items-center justify-center py-8">
                                    <svg className="animate-spin h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                                    </svg>
                                    <span className="ml-2 text-gray-500 text-sm">Loading tournaments...</span>
                                </div>
                            ) : reportsTournaments.length === 0 ? (
                                <p className="text-center text-gray-400 py-8 text-sm">No tournaments found.</p>
                            ) : (
                                <div className="space-y-2 max-h-80 overflow-y-auto pr-1">
                                    {reportsTournaments.map((t: any) => (
                                        <button
                                            key={t.CLAVE}
                                            onClick={() => {
                                                setShowReportsTournamentModal(false);
                                                navigate(`/admin/reports/${t.CLAVE}`, { state: { torneoNombre: t.NOMBRE } });
                                            }}
                                            className="w-full text-left px-4 py-3 rounded-xl border border-gray-200 hover:border-teal-400 hover:bg-teal-50 transition-colors"
                                        >
                                            <span className="font-semibold text-gray-900 text-sm">{t.NOMBRE}</span>
                                            {t.FECHAINICIO && (
                                                <span className="block text-xs text-gray-400 mt-0.5">
                                                    {new Date(t.FECHAINICIO).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' })}
                                                </span>
                                            )}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminDashboard;
